// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__GMGKI","title":"styles_title__V-i1j","subtitle":"styles_subtitle__3VyWL"};